/**
 *
 * Atualiza o estado de um objeto de pagamento com base no valor de um input.
 *
 * Esta função é utilizada como callback em eventos onChange de inputs. Ela extrai
 * o "name" e o "value" do evento e, usando a função de atualização de estado (setSelectedPayment),
 * atualiza de forma imutável o objeto de pagamento, preservando as demais propriedades.
 *
 * @param {Event} event - Evento gerado pelo input, contendo as propriedades name e value.
 * @param {Function} setSelectedPayment - Função para atualizar o estado do pagamento.
 */
export function allInputChange(event, setSelectedPayment) {
    const { name, value } = event.target;
    setSelectedPayment((prevState) => ({
        ...prevState,
        [name]: value,
    }));
}